import { createContext } from 'react';

export interface User {
    id: string;
    name: string;
    email: string;
    jobTitle: string;
    photoUrl?: string;
}

export interface AuthContextType {
    user: User | null;
    isAuthenticated: boolean;
    login: () => Promise<void>;
    logout: () => void;
    loading: boolean;
    loginError: string | null;
    retryLogin: () => Promise<void>;
    refreshUserProfile: () => Promise<void>;
    unauthorized?: boolean;
    stage?: 'initializing' | 'authenticating' | 'loading_profile' | 'finalizing';
}

export const AuthContext = createContext<AuthContextType>({
    user: null,
    isAuthenticated: false,
    login: async () => {},
    logout: () => {},
    loading: true,
    loginError: null,
    retryLogin: async () => {},
    refreshUserProfile: async () => {},
    unauthorized: false,
    stage: 'initializing',
});